import { RequestSpecialPermission, SpecialPermission } from "interfaces";
import { get, patch, post, remove } from "services/services.methods";
import { SpecialPermissionPath } from "services/services.paths";

export const FetchSpecialPermission = async () => {
  const response = await get<SpecialPermission[]>(
    SpecialPermissionPath.basePath
  );
  return response;
};

export const CreateSpecialPermission = async (
  data: RequestSpecialPermission
) => {
  const response = await post<SpecialPermission[]>(
    SpecialPermissionPath.post,
    data
  );

  return response;
};

export const UpdateSpecialPermission = async (
  id: number,
  data: RequestSpecialPermission
) => {
  const response = await patch<SpecialPermission[]>(
    SpecialPermissionPath.put + `/${id}`,
    data
  );
  return response;
};

export const DeleteSpecialPermission = async (
  id: number
) => {
  const response = await remove<SpecialPermission[]>(
    SpecialPermissionPath.delete + `/${id}`
  );
  return response;
};